// extracted by mini-css-extract-plugin
module.exports =  {"Spec":"Spec__tXPBe","imageBlock":"imageBlock__araUD"};